var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.708 13.549s-2.132-4.286-2.445-5.105a2.942 2.942 0 00-3.017-1.895H19.5V4.875A.875.875 0 0018.625 4h-5.25a.875.875 0 00-.875.875v1.674H9.754a2.938 2.938 0 00-3.017 1.895c-.313.819-2.445 5.105-2.445 5.105A3.036 3.036 0 002 16.519v7.53h1.75v1.4a2.16 2.16 0 004.318 0v-1.4h15.864v1.4a2.16 2.16 0 004.318 0v-1.4H30v-7.53a3.041 3.041 0 00-2.292-2.97zM8.767 9.207a1.312 1.312 0 01.886-.908h12.694a1.32 1.32 0 01.886.908l1.924 4.342H6.839l1.928-4.342zM6.58 20.323a1.894 1.894 0 01-1.924-1.843 1.938 1.938 0 011.923-1.895 1.894 1.894 0 011.873 1.895 1.85 1.85 0 01-1.855 1.843zm18.838 0a1.85 1.85 0 01-1.872-1.826v-.017a1.873 1.873 0 113.745-.04v.04a1.852 1.852 0 01-1.86 1.843z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--taxi-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'TaxiIcon';
export default Icon;